module.exports = __webpack_public_path__ + "images/entrega-paraguay---e9eeb72ff2731c90d5a1ff9dc96820c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/header/menu/img/entrega-paraguay.png
// module id = 384
// module chunks = 0